import Vue from 'vue'
//时间格式统一
Vue.filter('dateFormatToSecond', (originVal) => {
    if (originVal && originVal != '') {
        var date = new Date();
        date.setTime(originVal * 1000); //时间戳为微秒*1,毫秒*1000
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? ('0' + minute) : minute;
        second = second < 10 ? ('0' + second) : second;
        return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
    }
    else {
        return ''
    }

})
Vue.filter('dateFormatToDay', (originVal) => {
    if (originVal && originVal != '') {
        var date = new Date();
        date.setTime(originVal * 1000); //时间戳为微秒*1,毫秒*1000
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        return y + '-' + m + '-' + d;
    }
    else {
        return ''
    }

})
//订单状态筛选
Vue.filter('orderStatusFilter', (originVal) => {
    switch (originVal) {
        case '0':
            return '等待到库'
            break;
        case '1':
            return '待购买'
            break;
        case '2':
            return '购买完'
            break;

        case '4':
            return '到库'
            break;
        case '8':
            return '检品中'
            break;
        case '12':
            return '检品完'
            break;
        case '16':
            return '仓库保管中'
            break;
        case '20':
            return '申请发货'
            break;
        case '24':
            return '不良待处理'
            break;
        case '26':
            return '不良驳回'
            break;
        case '28':
            return '换货待发回'
            break;
        case '32':
            return '换货等待到货'
            break;
        case '36':
            return '待部分退货'
            break;
        case '40':
            return '补发等待到货'
            break;
        case '44':
            return '待支付'
            break;
        case '48':
            return '待发送'
            break;
        case '52':
            return '已发送'
            break;
        case '56':
            return '已取消'
            break;
        case '60':
            return '退货申请中'
            break;
        case '64':
            return '退货待支付'
            break;
        case '68':
            return '待退货'
            break;
        case '72':
            return '已退货'
            break;
        case '76':
            return '销毁申请中'
            break;
        case '80':
            return '销毁待支付'
            break;
        case '82':
            return '待部分销毁'
            break;
        case '83':
            return '待销毁'
            break;
        case '84':
            return '已销毁'
            break;
        case '88':
            return '检品完'
            break;
        case '89':
            return '无法购买'
            break;
    }
});
//不良件状态筛选
Vue.filter('problemStatusFilter', (originVal) => {
    switch (originVal) {
        case '1':
            return '待处理'
            break;
        case '2':
            return '处理中'
            break;
        case '3':
            return '处理完'
            break;
        case '4':
            return '已取消'
            break;
    }
});
//订单类型筛选
Vue.filter('orderTypeFilter', (originVal) => {
    switch (originVal) {
        case '0':
            return 'FBA';
            break;
        case '1':
            return '转送';
            break;
        case '2':
            return '装箱';
            break;
    }
});
//包装意向
Vue.filter('putIntentFilter', (originVal) => {
    switch (originVal) {
        case '0':
            return '袋装';
            break;
        case '1':
            return '纸箱';
            break;
        case '2':
            return '鞋盒';
            break;
        case '3':
            return '特殊箱子';
            break;
    }
});

//是or 否
Vue.filter('isornotFilter', (originVal) => {
    switch (originVal) {
        case '0':
            return '否';
            break;
        case '1':
            return '是';
            break;
    }
});
//FBA/YFF/RSL
Vue.filter('isFBA', (originVal) => {
    switch (originVal) {
        case '0':
            return 'FBA';
            break;
        case '1':
            return '否';
            break;
        case '2':
            return '乐天';
            break;
        case '3':
            return '第三方';
            break;
        case '5':
            return '无在库';
            break;
    }
});
//订单类型
Vue.filter('ordertypeFilter', (originVal) => {
    if (originVal == '1') {
        return '否';
    }
    if (originVal == '2') {
        return '乐天';
    }
    if (originVal == '0') {
        return 'FBA';
    }
    if (originVal == '3') {
        return '第三方';
    }
    if (originVal == '5') {
        return '无在库';
    }
});

//检品
Vue.filter('inspectionFilter', (originVal) => {
    switch (originVal) {
        case 'changeLabel':
            return '换标签';
            break;
        case 'subtractNeck':
            return '剪领标';
            break;
        case 'changeNeck':
            return '换领标';
            break;
        case 'subtractWash':
            return '剪水洗标';
            break;
        case 'changeWash':
            return '换水洗标';
            break;
        case 'punch':
            return '打孔';
            break;
        case 'clearFoul':
            return '消臭';
            break;
        case 'dry':
            return '干燥剂';
            break;
        case 'goods1':
            return '商品+1点';
            break;
        case 'changeSize':
            return '换尺寸标签';
            break;
        case 'goods2':
            return '商品+2点';
            break;
        case 'other':
            return '商品+其他附属品';
            break;
    }
});

//盘点状态
Vue.filter('checkStatusFilter', (originVal) => {
    switch (originVal) {
        case '0':
            return '未盘点'
            break;
        case '1':
            return '盘点通过'
            break;
        case '2':
            return '盘点未通过'
            break;
    }
})
//平台选择
Vue.filter('platformType', (originVal) => {
    switch (originVal) {
        case '0':
            return '淘宝'
            break;
        case '1':
            return '1688'
            break;
        case '2':
            return '京东'
            break;
        case '3':
            return '拼多多'
            break;

    }
})

//时间格式化
Vue.filter('formatDateFilter', (originVal) => {
    if (originVal == null || originVal == "") return "";
    let date = new Date(parseInt(originVal) * 1000);//时间戳为10位需*1000，如果为13位的话不需乘1000。
    let Y = date.getFullYear() + '-';
    let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-';
    let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
    let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
    let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
    let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    return Y + M + D + h + m + s;
})
